import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Tax Inquiry';

export const TIRoutes = [
  {
    path: '/tax/taxinquiry',
    name: 'Tax-Inquiry',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/TaxInquiry.vue'),
    children: [
      {
        path: 'taxrollsearch',
        name: 'Tax - Tax Inquiry - Tax Roll',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/TaxrollSearch.vue'),
      },
      {
        path: 'ownersearch',
        name: 'Tax - Tax Inquiry - Owner',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/OwnerSearch.vue'),
      },
      {
        path: 'mobile-home',
        name: 'Tax - Tax Inquiry - Mobile Home',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/MobileHome.vue'),
      },
      {
        path: 'reports',
        name: 'Tax - Tax Inquiry  - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/Reports.vue'),
        // The Reports tab is hidden for the view-only persona; typing the URL is refused too.
        beforeEnter: async (to, from, next) => {
          await accessCriteria([...authRoles.TaxRead, ...authRoles.TaxAuth], next);
        },
      },
    ],
  },
];

TIRoutes.forEach((element, index) => {
  TIRoutes[index].beforeEnter = async (to, from, next) => {
    // The one route that opts the sterilised "Tax Inquiry - view only" persona in. Every other
    // guard leaves allowTaxViewOnly off, so TaxInquiryViewOnly is stripped out of its role list
    // and the user is bounced Home.
    await accessCriteria(
      [...authRoles.TaxRead, ...authRoles.TaxAuth],
      next,
      { allowTaxViewOnly: true },
    );
  };
});

export default TIRoutes;
